import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-12">
          视频爆料
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaData.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-100 rounded-2xl overflow-hidden hover:scale-[1.01] transition-transform duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-accent-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-foreground-950 font-semibold text-sm leading-snug mb-2 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-400 text-xs">{item.info}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}